import { createSelector } from "reselect";

export const selectStore = (state) => state.store;

export const selectMerchant = createSelector(
  selectStore,
  (store) => store.merchant
);

export const selectStores = createSelector(
  selectStore,
  (store) => store.stores
);

export const selectSelectedStore = createSelector(
  selectStore,
  (store) => store.selectedStore
);

export const selectLocalization = createSelector(
  selectStore,
  (store) => store.localization
);

export const selectStockTypes = createSelector(
  selectStore,
  (store) => store.stockTypes
);
